export const Role = {
  levantador: 'levantador',
  ejecutivo: 'ejecutivo',
  asistente: 'asistente',
  jefe: 'jefe',
  administrador: 'administrador',
  gerente: 'gerente',
  developer: 'developer'
}

export const StateList = ['ingresada', 'asignada', 'aprobada', 'rechazada', 'por contactar', 'pendiente', 'eliminada', 'captada', 'vendida']

export const State = {
  levantador: ['ingresada'],
  ejecutivo: ['asignada', 'por contactar', 'pendiente', 'eliminada', 'captada', 'vendida'],
  asistente: ['asignada', 'aprobada', 'por contactar'],
  jefe: ['ingresada', 'asignada', 'aprobada', 'por contactar', 'pendiente', 'eliminada', 'captada', 'vendida'],
  developer: StateList
}

export const Result = {
  ingresada: [],
  asignada: [],
  aprobada: [],
  rechazada: [1, 2, 3, 4, 5],
  'por contactar': [],
  pendiente: [6, 7, 8, 9, 10, 11, 12, 13, 14],
  eliminada: [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],
  captada: [],
  vendida: []

  // rechazada: [21,22],
  // "por contactar": [1,2],
  // pendiente: [12,13,14,15,16,17,19],
  // eliminada: [3,4,5,6,7,8,9,10,11,18,20],
  // captada: [23]
}

// ESTADO PROPIEDAD
// ingresada, datos completos, revisada, aceptada, asignada, dueño contactado, en negociación, captada, eliminada
// ingresada, revisada, asignada

